import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'ScsSeqConfigModal',
  data: function data() {
    return {
      title: '操作',
      visible: false,
      categorys: 0,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入编号名称!'
          }]
        },
        seqLength: {
          rules: [{
            required: true,
            message: '请输入序号长度!'
          }]
        },
        preType: {
          rules: [{
            required: true,
            message: '请输入前缀类型!'
          }]
        },
        service: {
          rules: [{
            required: true,
            message: '请输入实现类!'
          }]
        },
        datePattern: {
          rules: [{
            required: true,
            message: '请输入日期生成格式!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择编号类型!'
          }]
        },
        curNumber: {
          rules: [{
            required: true,
            message: '请输入当前值!'
          }]
        },
        stepNumber: {
          rules: [{
            required: true,
            message: '请输入步长!'
          }]
        },
        remark: {
          rules: [{
            required: true,
            message: '请输入编号算法名称!'
          }]
        }
      },
      url: {
        add: '/sys/seq/add',
        edit: '/sys/seq/edit'
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (this.model.category != null) {
        this.categorys = this.model.category;
        this.model.category = this.model.category.toString();
      }

      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'code', 'seqLength', 'preType', 'curNumber', 'category', 'service', 'datePattern', 'stepNumber', 'remark')); //时间格式化

      });
    },
    handleChangeCategory: function handleChangeCategory(value) {
      this.categorys = value;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl += _this2.url.add;
            method = 'post';
          } else {
            httpurl += _this2.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values); //时间格式化

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};